"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumDialogName = void 0;
/**
 * The unique analytics name of the dialog. This is used as part of the event name for dialog open events.
 */
exports.EnumDialogName = {
    Announcement: 'Announcement',
    AudioPlayer: 'AudioPlayer',
    CantTakePoll: 'CantTakePoll',
    CarePlanIntroVideo: 'CarePlanIntroVideo',
    ConditionAdd: 'ConditionAdd',
    CrisisDialog: 'CrisisDialog',
    CrisisReferralDialog: 'CrisisReferralDialog',
    ChangeOfSponsorshipFnfWarning: 'ChangeOfSponsorshipFnfWarning',
    DismissProgramDialog: 'DismissProgramDialog',
    EligibilityNotConfirmed: 'EligibilityNotConfirmed',
    GadScaleInfo: 'GadScaleInfo',
    GoalsTopicInfoVideoPlayer: 'GoalsTopicInfoVideoPlayer',
    HealthSummaryLoading: 'HealthSummaryLoading',
    HowToGetStarted: 'HowToGetStarted',
    ReconsentCancelConfirmationDialog: 'ReconsentCancelConfirmationDialog',
    JoinBeforeFavoritingProgram: 'JoinBeforeFavoritingProgram',
    JoinBeforeViewingProgram: 'JoinBeforeViewingProgram',
    LearnWhyScreen: 'LearnWhyScreen',
    LookingForCalmApp: 'LookingForCalmApp',
    NoAccessCode: 'NoAccessCode',
    PhqScaleInfo: 'PhqScaleInfo',
    NpsPoll: 'NpsPoll',
    PostSessionNextRecommendation: 'PostSessionNextRecommendation',
    PostSessionProgramCompleted: 'PostSessionProgramCompleted',
    ProgramBinge: 'ProgramBinge',
    ProgramContributor: 'ProgramContributor',
    ProgramGuidePlayer: 'ProgramGuidePlayer',
    ProgramGuidePrerequisites: 'ProgramGuidePrerequisites',
    ProgramInProgress: 'ProgramInProgress',
    ProgramCompletionCelebrationVideoPlayer: 'ProgramCompletionCelebrationVideoPlayer',
    RegistrationDialog: 'RegistrationDialog',
    RegistrationCountry: 'RegistrationCountry',
    RegistrationCountryError: 'RegistrationCountryError',
    DependentRegistrationError: 'DependentRegistrationError',
    RedirectRegistration: 'RedirectRegistration',
    SecurityValuedDialog: 'SecurityValuedDialog',
    ServerError: 'ServerError',
    SkipAccessCode: 'SkipAccessCode',
    SkipEligibility: 'SkipEligibility',
    StepDialogConfirm: 'StepDialogConfirm',
    Toast: 'Toast',
    VideoPlayer: 'VideoPlayer',
    UpgradeTakeover: 'UpgradeTakeover',
    ProgramJoinDialog: 'ProgramJoinDialog',
    RewardSelectionDialog: 'RewardSelectionDialog',
    RewardSelectionDetailsDialog: 'RewardSelectionDetailsDialog',
    RewardSelectionSkipDialog: 'RewardSelectionSkipDialog',
    RewardClaimedConfirmationDialog: 'RewardClaimedConfirmationDialog',
    RewardClaimedErrorDialog: 'RewardClaimedErrorDialog',
    AppealsAndGrievances: 'AppealsAndGrievances',
    BenefitInformation: 'BenefitInformation',
    CareProfileCreate: 'CareProfileCreate',
    CareTeamLeave: 'CareTeamLeave',
    CareTeamRelationship: 'CareTeamRelationship',
    CareTeamRemoveCaregiver: 'CareTeamRemoveCaregiver',
    Confirm: 'Confirm',
    ConfirmLogout: 'ConfirmLogout',
    ContactCreate: 'ContactCreate',
    ContactDelete: 'ContactDelete',
    ContactEdit: 'ContactEdit',
    DeleteAccount: 'DeleteAccount',
    DocumentCreate: 'DocumentCreate',
    DocumentDelete: 'DocumentDelete',
    DocumentEdit: 'DocumentEdit',
    DocumentEssentialDetail: 'DocumentEssentialDetail',
    DuplicateInvite: 'DuplicateInvite',
    EmailAdd: 'EmailAdd',
    EmailEdit: 'EmailEdit',
    HelpDialog: 'HelpDialog',
    InviteCreate: 'InviteCreate',
    InviteDetail: 'InviteDetail',
    InviteStatus: 'InviteStatus',
    InviteWithdraw: 'InviteWithdraw',
    MessageDiscardDraft: 'MessageDiscardDraft',
    MindshiftPromo: 'MindshiftPromo',
    NoRecipientsDialog: 'NoRecipientsDialog',
    NotificationPreferencesEdit: 'NotificationPreferencesEdit',
    NotMapped: 'NotMapped',
    OldProfileDiscard: 'OldProfileDiscard',
    OutOfOfficeRepliesDismiss: 'OutOfOfficeRepliesDismiss',
    OutOfOfficeRepliesSuccess: 'OutOfOfficeRepliesSuccess',
    ProfileCreate: 'ProfileCreate',
    ProfileEdit: 'ProfileEdit',
    ProfileMenu: 'ProfileMenu',
    ProfileSelect: 'ProfileSelect',
    ReadOnlyAccess: 'ReadOnlyAccess',
    ServerError2: 'ServerError',
    SlowLoading: 'SlowLoading',
    Survey: 'Survey',
    TaskAdd: 'TaskAdd',
    TaskAssign: 'TaskAssign',
    TaskChangeSchedule: 'TaskChangeSchedule',
    TaskEdit: 'TaskEdit',
    UserAccountDeactivate: 'UserAccountDeactivate',
    UserAccountEdit: 'UserAccountEdit',
    UserAccountPhotoEdit: 'UserAccountPhotoEdit',
    VerifyEmail: 'VerifyEmail',
    ConditionSavedDialog: 'ConditionSavedDialog',
    ConditionDeletedDialog: 'ConditionDeletedDialog',
    ConditionDeleteConfirmDialog: 'ConditionDeleteConfirmDialog',
    ConditionsInfoVideoPlayer: 'ConditionsInfoVideoPlayer',
    QuitScreening: 'QuitScreening',
    SkipScreening: 'SkipScreening',
    ScreeningQuitConfirmDialog: 'ScreeningQuitConfirmDialog',
    ScreeningInfoVideoPlayer: 'ScreeningInfoVideoPlayer',
    ConsumerHealthDataConsent: 'ConsumerHealthDataConsent',
    MhsRetriggerSkipThisMonthDialog: 'MHSRetriggerSkipThisMonthDialog',
    Invite: 'Invite',
    EmailDialog: 'EmailDialog',
    WithdrawInviteDialog: 'WithdrawInviteDialog',
    RevokeInviteDialog: 'RevokeInviteDialog',
    PendingToast: 'PendingToast',
    CopyToast: 'CopyToast',
    EmailPreferencesConfirmed: 'EmailPreferencesConfirmed',
    UnderageNoAccessWarning: 'UnderageNoAccessWarning',
    ResourceSheetDialog: 'ResourceSheetDialog',
    ActivitySheet: 'ActivitySheet',
    ActivityLimitReached: 'ActivityLimitReached',
    SkipPage: 'SkipPage',
    MindBodyConnection: 'MindBodyConnection',
    EmotionIntensityScale: 'EmotionIntensityScale',
    CheckInBreakdownUnlocked: 'CheckInBreakdownUnlocked',
    RecommendationFeedback: 'RecommendationFeedback',
    TrackNotAdded: 'TrackNotAdded',
    ConfirmDeletePlaylist: 'ConfirmDeletePlaylist',
    PlaylistLimit: 'PlaylistLimit',
    CustomizeShortcuts: 'CustomizeShortcuts',
};
//# sourceMappingURL=enum-dialog-name.js.map